function toE164(rawPhone, dialCode) {
  const raw = String(rawPhone || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  if (raw.startsWith('+')) return '+' + digits;          // user typed +971..., +1..., etc.
  if (raw.startsWith('00')) return '+' + digits.slice(2); // 0044... style

  const cc = String(dialCode || '').replace(/\D/g, '');   // from the form's country selector
  if (!cc) return '';                                     // country unknown: don't guess
  return '+' + cc + digits.replace(/^0+/, '');            // drop a leading trunk zero
}

export function pushLeadSuccess(values) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'lead_form_success',
    lead_budget: values.budget || '',
    lead_space_type: values.spaceType || '',
    user_data: {
      email: String(values.email || '').trim().toLowerCase(),
      phone_number: toE164(values.mobile, values.countryCode)
    }
  });
}